export enum MOVEIN_DOC_TYPES {
  TAQA_REGISTRATION_BILL = "TAQA REGISTRATION BILL",
  DISTRICT_COOLING_CLEARANCE = "District Cooling Transfer",
}

const initialFileDetails = {
  file: undefined,
  fileName: "",
  downloadUrl: "",
};

export const uploadDocumentInitialState = {
  values: {
    taqaRegistration: initialFileDetails,
    districtCoolingClearance: initialFileDetails,
  },
  loading: {
    taqaRegistration: false,
    districtCoolingClearance: false,
  },
  errors: {
    taqaRegistration: false,
    districtCoolingClearance: false,
  },
};
export const MOVEIN_SR_TYPE = "Aldar Estates Move-In";
export const NOC_SR_TYPE = "Property Transfer NOC";
export const APPROVED_STATUS = "Approved";
export const CLOSED_STATUS = "Closed";

export const CANCELED_LABEL = "Canceled";
export const APPROVED_LABEL = "Approved";
export const IN_PROGRESS_LABEL = "In_Progress";
export const CLOSED_LABEL = "Closed";

export const CANCELLED_CHECK_VALUE = "cancelled";
export const CLOSED_CHECK_VALUE = "closed";
export const IN_PROGRESS_VALUE = "in progress";
export const SUBMITTED_VALUE = "submitted";
export const ISSUE_NOC_STEP = "Issue NOC to Client";
export const STATUS_NOC_ISSUE_STATUS = "NOC Issued via Email";
export const NOC_ISSUE_PHYSICALLY = "NOC Issued via Physically";

export const MOVEOUT_SR_TYPE = "Aldar Estates Move-Out";
